/**
 *
 * Asynchronously loads the component for NewCompany
 *
 */

import { lazyLoad } from 'utils/loadable';

export const NewCompany = lazyLoad(
  () => import('./index'),
  module => module.NewCompany,
);
